import React from 'react'
import styled from '@emotion/styled'
import {css} from '@emotion/core'

import LanguageSelector from './LanguageSelector/Desktop'
import CurrencySelector from './CurrencySelector/Desktop'

import {PropsType} from './types'

const SelectorContainer = styled('div')(
  ({theme}) => css`
    display: flex;
    position: relative;
    margin-left: ${theme.layout.spacing.s600}px;
  `
)

const PreferenceSelectorDesktop = ({
  currentLanguage,
  availableLanguages,
  currentCurrency,
  currenciesList,
  popularCurrenciesList,
  onChangeLanguage,
  onChangeCurrency,
  hasLanguageSelector = true,
  hasCurrencySelector = true,
  onClickLanguage,
  onClickCurrency
}: PropsType) => {
  return (
    <SelectorContainer>
      {hasLanguageSelector && (
        <LanguageSelector
          currentLanguage={currentLanguage}
          availableLanguages={availableLanguages}
          onChangeLanguage={onChangeLanguage}
          onClick={onClickLanguage}
        />
      )}
      {hasCurrencySelector && (
        <CurrencySelector
          currentCurrency={currentCurrency}
          currenciesList={currenciesList}
          popularCurrenciesList={popularCurrenciesList}
          onChangeCurrency={onChangeCurrency}
          onClick={onClickCurrency}
        />
      )}
    </SelectorContainer>
  )
}

export default PreferenceSelectorDesktop
